const ModalEditPhotoMyComp = {
  title: 'Editar logo da Empresa'
};

export default ModalEditPhotoMyComp;
